import { render, staticRenderFns } from "./app-android.vue?vue&type=template&id=2a67c53d&scoped=true"
import script from "./app-android.vue?vue&type=script&lang=js"
export * from "./app-android.vue?vue&type=script&lang=js"
import style0 from "./app-android.vue?vue&type=style&index=0&id=2a67c53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67c53d",
  null
  
)

export default component.exports